var map = {
	"./icon-api-user.svg": "1e20",
	"./icon-apply-record.svg": "6e01",
	"./icon-balance.svg": "db24",
	"./icon-bill.svg": "0cca",
	"./icon-com-auth.svg": "b054",
	"./icon-com-info.svg": "5261",
	"./icon-commission.svg": "400f",
	"./icon-company-relev.svg": "12d2",
	"./icon-complianceTask.svg": "6bf4",
	"./icon-contract.svg": "c6fa",
	"./icon-door.svg": "d033",
	"./icon-employeeCertification.svg": "42f4",
	"./icon-help.svg": "25a4",
	"./icon-home.svg": "2eec",
	"./icon-hro-project.svg": "b854",
	"./icon-hro-staff.svg": "0f96",
	"./icon-invoice.svg": "ec90",
	"./icon-recruitment.svg": "c4ff",
	"./icon-secure.svg": "6cd2",
	"./icon-sub-account.svg": "a51c",
	"./icon-task.svg": "0892",
	"./icon-wallet.svg": "ba98",
	"./icon-zb-dataCentre.svg": "39e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";